var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Источник исполнителей",
      "create-text": "Новый",
      "fetch-data": _vm.fetchData,
      "route-create": "WorkerSourceAdd",
      "route-edit": "WorkerSourceEdit",
      "route-view": "WorkerSourceView",
      "route-path": "/worker_sources",
      "can-edit": _vm.canEditWorkerSourceCatalogs()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a5f4a40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a5f4a40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/WorkerSources/WorkerSources.vue
// module id = null
// module chunks = 